import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {prepareNewWindowUrl} from '../../../utilities/StringHelpers/StringHelpers';

export default function BottomLinks(props) {
  return (
    <div className='bottom-container'>
      <p className='bottom-text'>
        הסתבכתם? משהו לא עובד?
        <br />
        נסו מדריך שהכנו עבורכם
      </p>
      <div className='bottom-container-links'>
        <a onClick={() => props.setPopUp(true)}>לסרטון הדרכה</a>
        <a onClick={() => prepareNewWindowUrl(props.iContent?.esimWhatsAppUrl?.value, props.context)}>
          <Image className='whats-app-icon' src={require('./EsimIcons/whats-app-icon.svg')} />
          לנציג שירות
        </a>
      </div>
    </div>
  );
}
